import { Component } from '@angular/core';

import { QuickbetPartialOverlaySelectionComponent } from '../../../quickbet/components/quickbetPartialOverlaySelection/quickbet-partial-overlay-selection.component';

@Component({
    selector: 'srm-quickbet-partial-overlay-selection',
    templateUrl: 'srm-quickbet-partial-overlay-selection.component.html',
    styleUrls: [
        '../../../quickbet/components/quickbetPartialOverlaySelection/quickbet-partial-overlay-selection.component.scss',
        'srm-quickbet-partial-overlay-selection.component.scss',
    ],
    standalone: false,
})
export class SrmQuickbetPartialOverlaySelectionComponent extends QuickbetPartialOverlaySelectionComponent {}
